"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "FormulaGeneralHandler", {
    enumerable: true,
    get: function() {
        return FormulaGeneralHandler;
    }
});
const _nocodbsdk = require("nocodb-sdk");
const _computed = require("../computed");
const _formulaQueryBuilderv2 = /*#__PURE__*/ _interop_require_default(require("~/db/formulav2/formulaQueryBuilderv2"));
const _models = require("~/models");
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
let FormulaGeneralHandler = class FormulaGeneralHandler extends _computed.ComputedFieldHandler {
    async filter(knex, filter, column, options) {
        var _filter_value;
        const { context, conditionParser: parseConditionV2, baseModel: baseModelSqlv2, alias, depth: aliasCount } = options;
        const model = await column.getModel(context);
        const formula = await column.getColOptions(context);
        const builder = (await (0, _formulaQueryBuilderv2.default)({
            baseModel: baseModelSqlv2,
            tree: formula.formula,
            model,
            column,
            tableAlias: alias
        })).builder;
        const parsedTree = formula.getParsedTree();
        const value = parsedTree.dataType === _nocodbsdk.FormulaDataTypes.DATE ? filter.value : knex.raw('?', [
            // convert value to number if formulaDataType if numeric
            (parsedTree == null ? void 0 : parsedTree.dataType) === _nocodbsdk.FormulaDataTypes.NUMERIC && !isNaN(+filter.value) ? +filter.value : (_filter_value = filter.value) != null ? _filter_value : null
        ]);
        return parseConditionV2(baseModelSqlv2, new _models.Filter(_extends({}, filter, {
            value
        })), aliasCount, alias, builder);
    }
    async verifyFilter(filter, column, options = {}) {
        const uidt = (0, _nocodbsdk.parseProp)(column.meta).display_type;
        if (uidt) {
            const updatedColumn = new _models.Column(_extends({}, column, {
                uidt: uidt
            }));
            return options.fieldHandler.verifyFilter(filter, updatedColumn, options);
        } else {
            const formulaCol = await column.getColOptions(options.context);
            const parsedTree = await formulaCol.getParsedTree();
            const setColumnTypeAndVerify = (type)=>{
                const updatedColumn = new _models.Column(_extends({}, column, {
                    uidt: type
                }));
                return options.fieldHandler.verifyFilter(filter, updatedColumn, options);
            };
            if (!(parsedTree == null ? void 0 : parsedTree.dataType)) {
                return setColumnTypeAndVerify(_nocodbsdk.UITypes.SingleLineText);
            }
            const dataType = parsedTree.dataType;
            switch(dataType){
                case _nocodbsdk.FormulaDataTypes.BOOLEAN:
                    return setColumnTypeAndVerify(_nocodbsdk.UITypes.Checkbox);
                case _nocodbsdk.FormulaDataTypes.DATE:
                    return setColumnTypeAndVerify(_nocodbsdk.UITypes.DateTime);
                case _nocodbsdk.FormulaDataTypes.INTERVAL:
                    return setColumnTypeAndVerify(_nocodbsdk.UITypes.Time);
                case _nocodbsdk.FormulaDataTypes.NUMERIC:
                    return setColumnTypeAndVerify(_nocodbsdk.UITypes.Decimal);
                case _nocodbsdk.FormulaDataTypes.STRING:
                default:
                    return setColumnTypeAndVerify(_nocodbsdk.UITypes.SingleLineText);
            }
        }
        return {
            isValid: true
        };
    }
};
